import React from 'react';
import { Box, Grid } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const Row = ({
  layerStyle,
  height,
  children,
  fontSize,
  marginBottom,
  marginTop,
  clickable,
  minWidth,
  columns,
  gap,
  onClick,
  ...styles
}) => (
  <Box
    _hover={clickable && { boxShadow: 'hover', cursor: 'pointer' }}
    alignItems="center"
    borderRadius="md"
    fontSize={fontSize}
    layerStyle={layerStyle}
    mb={marginBottom}
    minHeight={height}
    minW={minWidth}
    mt={marginTop}
    px={3}
    py={3}
    width="100%"
    onClick={onClick}
    {...styles}
  >
    <Grid
      alignItems="center"
      gap={gap}
      justifyContent="center"
      minHeight={`calc(${height} - 1.5rem)`}
      templateColumns={columns}
    >
      {children}
    </Grid>
  </Box>
);

Row.propTypes = {
  layerStyle: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node]),
  height: PropTypes.string,
  fontSize: PropTypes.string,
  marginBottom: PropTypes.number,
  marginTop: PropTypes.number,
  /** If `clickable=true` row will have hover styles */
  clickable: PropTypes.bool,
  minWidth: PropTypes.string,
  /** Grid template columns */
  columns: PropTypes.string,
  gap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func
};

Row.defaultProps = {
  layerStyle: 'row',
  height: '70px',
  fontSize: 'inherit',
  marginBottom: 5,
  marginTop: 0,
  clickable: true,
  minWidth: '880px',
  columns: null,
  gap: 0,
  onClick: () => {}
};

export default Row;
